import { SYMBOLS } from "@dfds-activity-map/svgs/symbols";
import { createFileRoute } from "@tanstack/solid-router";

import { Admin } from "@/components/editor/admin";
import { HOME_PERSPECTIVE_SLUG } from "@/scripts/const";
import { setAdminUIStore } from "@/scripts/store";

import editorCss from "@/styles/editor.css?url";

const Route = createFileRoute("/core/admin")({
	ssr: false,
	head: () => ({
		links: [
			{ rel: "stylesheet", href: editorCss },
			{
				rel: "stylesheet",
				href: `https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=${SYMBOLS.join(",")}`,
			},
		],
	}),
	component: () => {
		setAdminUIStore({ core: true });

		return <Admin slug={HOME_PERSPECTIVE_SLUG} />;
	},
});

export { Route };
